import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { AdmintoolOperationFactory } from '@admintool/operation/admintool-operation.factory';
import { AdmintoolMaterialsService, EditMaterialsInfo } from '@admintool/services/admintool-materials.service';
import { UndoRedoHelper } from '@shared/undo/undo-redo.helper';
import { CustomValidators } from '@shared/custom-validators';
import { FormValidValidatorDirective } from '@shared/form-validator.directive';
import { ValidatorDirective } from '@shared/validator.directive';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-edit-article-materials',
  imports: [
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    ValidatorDirective,
    FormValidValidatorDirective
  ],
  templateUrl: './edit-article-materials.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditArticleMaterialsComponent {

  public materialsInfo = signal<EditMaterialsInfo[]>([]);

  public hexValidator = CustomValidators.hexColor();

  allColorsValid = signal<boolean>(false);

  constructor(
    private bsModalRef: BsModalRef,
    private admintoolMaterialsService: AdmintoolMaterialsService,
    private undoRedoHelper: UndoRedoHelper,
    private admintoolOperationFactory: AdmintoolOperationFactory,
  ) {
    this.materialsInfo.set(this.collectMaterialsByColor());
  }

  public applyMaterialChanges(): void {
    const oldMaterials = this.collectMaterialsByColor();

    this.admintoolMaterialsService.applyMaterialChanges(this.materialsInfo());

    const newMaterials = this.collectMaterialsByColor();
    const operation = this.admintoolOperationFactory.createEditArticleMaterialsOperation(oldMaterials, newMaterials);

    this.undoRedoHelper.pushUndoOperation(operation);

    this.bsModalRef.hide();
  }

  public cancel(): void {
    this.bsModalRef.hide();
  }

  private collectMaterialsByColor(): EditMaterialsInfo[] {
    const materialsByHexCodeAndOpacity = this.admintoolMaterialsService.getSceneMaterialsByHexCodeAndOpacity()

    return Array.from(materialsByHexCodeAndOpacity,
        ([colorKey, materials]) => {
          const colorToUse = `#${colorKey.split('-')[0]}`;
          const opacityToUse = parseFloat(colorKey.split('-')[1]);
          return {colorToUse, opacityToUse, materials};
        }
      );
  }
}
